function RefreshIcon({
    width = 13,
    height = 13,
    color = "white",
    className = "",
    viewBox = "0 0 13 13"
}) {


    return  <svg 
                width={width} 
                height={height} 
                viewBox={viewBox} 
                fill="none" 
                xmlns="http://www.w3.org/2000/svg"
            >
                <path 
                    d="M6.25 12.5C4.50514 12.5 3.02729 11.8947 1.81646 10.684C0.605486 9.47326 0 7.99569 0 6.25125C0 4.50681 0.605486 3.02882 1.81646 1.81729C3.02729 0.605764 4.50514 0 6.25 0C7.22431 0 8.14632 0.216597 9.01604 0.649792C9.88562 1.08313 10.6089 1.69451 11.1858 2.48396V0.625C11.1858 0.447917 11.2458 0.299514 11.3656 0.179792C11.4855 0.0599307 11.634 0 11.811 0C11.9883 0 12.1367 0.0599307 12.2563 0.179792C12.376 0.299514 12.4358 0.447917 12.4358 0.625V4.34292C12.4358 4.55639 12.3637 4.73528 12.2194 4.87958C12.0749 5.02389 11.896 5.09604 11.6827 5.09604H7.96479C7.78771 5.09604 7.63924 5.03618 7.51937 4.91646C7.39965 4.7966 7.33979 4.64806 7.33979 4.47083C7.33979 4.29375 7.39965 4.14535 7.51937 4.02562C7.63924 3.90604 7.78771 3.84625 7.96479 3.84625H10.6315C10.1923 3.04167 9.58326 2.40785 8.80438 1.94479C8.02563 1.4816 7.17417 1.25 6.25 1.25C4.86111 1.25 3.68056 1.73611 2.70833 2.70833C1.73611 3.68056 1.25 4.86111 1.25 6.25C1.25 7.63889 1.73611 8.81944 2.70833 9.79167C3.68056 10.7639 4.86111 11.25 6.25 11.25C7.21847 11.25 8.10507 10.9957 8.90979 10.4871C9.71451 9.97861 10.3242 9.30021 10.7387 8.45188C10.8178 8.30021 10.934 8.19417 11.0873 8.13375C11.2406 8.07347 11.3969 8.07 11.556 8.12333C11.7259 8.17681 11.8448 8.28792 11.9127 8.45667C11.9805 8.62556 11.9749 8.78583 11.8958 8.9375C11.3797 10.0165 10.6179 10.88 9.61042 11.5279C8.60292 12.176 7.48278 12.5 6.25 12.5Z" 
                    fill={color}
                />
            </svg>
}
export { RefreshIcon };